export async function hkdfSha256(ikm, salt, info, length) {
    const baseKey = await crypto.subtle.importKey("raw", ikm, "HKDF", false, ["deriveBits"]);
    const bits = await crypto.subtle.deriveBits({
        name: "HKDF",
        hash: "SHA-256",
        salt: salt,
        info: new TextEncoder().encode(info),
    }, baseKey, length * 8);
    return new Uint8Array(bits);
}
//# sourceMappingURL=hkdf.js.map